var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotPatternVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.985,
    cy: 352.159,
    r: 2.648,
    transform: "rotate(-180 157.985 352.159)",
    fill: "#70C217"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 352.159,
    r: 2.648,
    transform: "rotate(-180 119.151 352.159)",
    fill: "#70C217"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 352.159,
    r: 2.648,
    transform: "rotate(-180 80.317 352.159)",
    fill: "#70C217"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 352.159,
    r: 2.648,
    transform: "rotate(-180 41.482 352.159)",
    fill: "#70C217"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 352.159,
    r: 2.648,
    transform: "rotate(-180 2.648 352.159)",
    fill: "#70C217"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 313.325,
    r: 2.648,
    transform: "rotate(-180 157.986 313.325)",
    fill: "#70C217"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 313.325,
    r: 2.648,
    transform: "rotate(-180 119.151 313.325)",
    fill: "#70C217"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 313.325,
    r: 2.648,
    transform: "rotate(-180 80.317 313.325)",
    fill: "#70C217"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 313.325,
    r: 2.648,
    transform: "rotate(-180 41.482 313.325)",
    fill: "#70C217"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 313.325,
    r: 2.648,
    transform: "rotate(-180 2.648 313.325)",
    fill: "#70C217"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 274.489,
    r: 2.648,
    transform: "rotate(-180 157.986 274.489)",
    fill: "#70C217"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 274.489,
    r: 2.648,
    transform: "rotate(-180 119.151 274.489)",
    fill: "#70C217"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 274.489,
    r: 2.648,
    transform: "rotate(-180 80.317 274.489)",
    fill: "#70C217"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 274.489,
    r: 2.648,
    transform: "rotate(-180 41.482 274.489)",
    fill: "#70C217"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 274.489,
    r: 2.648,
    transform: "rotate(-180 2.648 274.489)",
    fill: "#70C217"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 235.655,
    r: 2.648,
    transform: "rotate(-180 157.986 235.655)",
    fill: "#70C217"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 235.655,
    r: 2.648,
    transform: "rotate(-180 119.151 235.655)",
    fill: "#70C217"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 235.655,
    r: 2.648,
    transform: "rotate(-180 80.317 235.655)",
    fill: "#70C217"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 235.655,
    r: 2.648,
    transform: "rotate(-180 41.482 235.655)",
    fill: "#70C217"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 235.655,
    r: 2.648,
    transform: "rotate(-180 2.648 235.655)",
    fill: "#70C217"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 196.821,
    r: 2.648,
    transform: "rotate(-180 157.986 196.821)",
    fill: "#70C217"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 196.821,
    r: 2.648,
    transform: "rotate(-180 119.151 196.821)",
    fill: "#70C217"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 196.821,
    r: 2.648,
    transform: "rotate(-180 80.317 196.821)",
    fill: "#70C217"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 196.821,
    r: 2.648,
    transform: "rotate(-180 41.482 196.821)",
    fill: "#70C217"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 196.821,
    r: 2.648,
    transform: "rotate(-180 2.648 196.821)",
    fill: "#70C217"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 157.987,
    r: 2.648,
    transform: "rotate(-180 157.986 157.987)",
    fill: "#70C217"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 157.987,
    r: 2.648,
    transform: "rotate(-180 119.151 157.987)",
    fill: "#70C217"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 157.987,
    r: 2.648,
    transform: "rotate(-180 80.317 157.987)",
    fill: "#70C217"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 157.987,
    r: 2.648,
    transform: "rotate(-180 41.482 157.987)",
    fill: "#70C217"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 157.987,
    r: 2.648,
    transform: "rotate(-180 2.648 157.987)",
    fill: "#70C217"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-180 157.986 119.151)",
    fill: "#70C217"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-180 119.151 119.151)",
    fill: "#70C217"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-180 80.317 119.151)",
    fill: "#70C217"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-180 41.482 119.151)",
    fill: "#70C217"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-180 2.648 119.151)",
    fill: "#70C217"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 80.317,
    r: 2.648,
    transform: "rotate(-180 157.986 80.317)",
    fill: "#70C217"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 80.317,
    r: 2.648,
    transform: "rotate(-180 119.151 80.317)",
    fill: "#70C217"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 80.317,
    r: 2.648,
    transform: "rotate(-180 80.317 80.317)",
    fill: "#70C217"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 80.317,
    r: 2.648,
    transform: "rotate(-180 41.482 80.317)",
    fill: "#70C217"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 80.317,
    r: 2.648,
    transform: "rotate(-180 2.648 80.317)",
    fill: "#70C217"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 41.483,
    r: 2.648,
    transform: "rotate(-180 157.986 41.483)",
    fill: "#70C217"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 41.483,
    r: 2.648,
    transform: "rotate(-180 119.151 41.483)",
    fill: "#70C217"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 41.483,
    r: 2.648,
    transform: "rotate(-180 80.317 41.483)",
    fill: "#70C217"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 41.483,
    r: 2.648,
    transform: "rotate(-180 41.482 41.483)",
    fill: "#70C217"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 41.483,
    r: 2.648,
    transform: "rotate(-180 2.648 41.483)",
    fill: "#70C217"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 2.649,
    r: 2.648,
    transform: "rotate(-180 157.986 2.65)",
    fill: "#70C217"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 2.649,
    r: 2.648,
    transform: "rotate(-180 119.151 2.65)",
    fill: "#70C217"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 2.649,
    r: 2.648,
    transform: "rotate(-180 80.317 2.65)",
    fill: "#70C217"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 2.649,
    r: 2.648,
    transform: "rotate(-180 41.482 2.65)",
    fill: "#70C217"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 2.649,
    r: 2.648,
    transform: "rotate(-180 2.648 2.65)",
    fill: "#70C217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPatternVertical);
export default __webpack_public_path__ + "static/media/dot-pattern-vertical.5394039d.svg";
export { ForwardRef as ReactComponent };